// src/router/index.js

import { createRouter, createWebHistory } from "vue-router"; // Vue 3 專用寫法

// 匯入主要頁面 (你也可以放在 views 或 components 都可以)
import Home from "@/components/HomePage.vue"; // 首頁

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home, // 指定首頁元件
    meta: {
      title: "CC輔助商城 - 首頁", // 註解：這是首頁標題
      description: "頂級遊戲外掛、輔助工具、安全可靠，馬上體驗！", // 註解：這是首頁描述
    },
  },

  {
    path: "/:catchAll(.*)",
    redirect: "/", // 其他不存在路徑都導回首頁
  },
]; // routes 陣列每條路徑配對一個元件
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 平滑滾動到頁面頂部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: "smooth" };
    }
  },
});

export default router; // 匯出 router 讓 main.js 使用
// 這份 Option API 完全支援 Vue 3、你的元件寫法不需要修改
